import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PassDataService } from '../../services/pass-data/pass-data.service';
import { first } from 'rxjs';
import { SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'urban-alert-panel',
    templateUrl: './alert-panel.component.html',
    styleUrls: ['./alert-panel.component.scss'],
    standalone: false
})
export class AlertPanelComponent implements OnInit {
  @Input() public boldPrefix: string = '';
  @Input() public titleText: string = '';
  @Input() public descriptionText: string = '';
  @Input() public alertType: 'error' | 'warning' | 'info';
  @Input() public buttonLabel: string;
  @Input() public overlayPanel: boolean = false;

  @Output() private buttonAction = new EventEmitter();
  // eslint-disable-next-line @angular-eslint/no-output-rename, @angular-eslint/no-output-native
  @Output('close') private closeEvent = new EventEmitter();

  public icons: Record<string, SafeHtml> = {};

  constructor(private passDataService: PassDataService) { }

  ngOnInit(): void {
    this.passDataService.sanIcons$.pipe(first())
      .subscribe(response => {
        this.icons = response;
      });
  }

  public execAction(): void {
    this.buttonAction.emit();
  }

  public closePanel(): void {
    this.closeEvent.emit();
  }
}
